import React from 'react';
import enhance from './enhance';
import FunctionalGroup from '../FunctionalGroup';
import styles from './styles.module.scss';
import LockedWarning from '../LockedWarning';

export const Model = ({
  inReviewView,
  locked,
  lockedBackground,
  model,
  modelDetailStyles,
  searchView,
  triggerSearch,
  closeGolbalSearch,
}) =>
  locked ? (
    <LockedWarning lockedBackground={lockedBackground} />
  ) : (
    <div className={modelDetailStyles} id="workingStateView">
      <div className={styles.modelTemplates}>
        {model.functionalGroups &&
          model.functionalGroups.map(functionalGroupId => {
            return (
              <FunctionalGroup
                inReviewView={inReviewView}
                searchView={searchView}
                key={functionalGroupId}
                functionalGroupId={functionalGroupId}
                triggerSearch={triggerSearch}
                closeGolbalSearch={closeGolbalSearch}
              />
            );
          })}
      </div>
    </div>
  );

export default enhance(Model);
